import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class SettingsService {
    static fetchCustomizableRegionSettings() {
        return lastValueFrom(BaseService.get(`customizable-region-settings`));
    }
    static saveCustomizableRegionSettings(dto) {
        return lastValueFrom(BaseService.save(`customizable-region-settings`, dto));
    }
}
